// extracted by mini-css-extract-plugin
export default {"button":"Button_button__ZuQ53","text":"Button_text__ysb1E","identifyButton":"Button_identifyButton__e0SVO","downloadButton":"Button_downloadButton__+xBbN"};